import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { TransformButton } from "./CtaButton";
const painPoints = ["Improvisando cada presupuesto.", "Cobrando sin saber si realmente ganas dinero.", "Atendiendo clientes sin ningún proceso.", "Perdiendo horas buscando herramientas o documentos.", "Olvidando hacer seguimiento.", "Regalando garantías.", "Empezando cada mes desde cero."];
const clientNotices = ["cómo cotizas", "cómo entregas una orden de servicio", "cómo explicas una garantía", "cómo organizas tu trabajo", "cómo haces seguimiento", "cómo transmites confianza"];
export function ProblemSection() {
  return <section className="w-full bg-neutral-950 py-14" data-id="element-137" data-mp="3jdpmqxe6t73h">
      <div className="mx-auto max-w-lg px-4" data-id="element-138" data-mp="3ei0fs8zu8nx5">
        <p className="text-center font-display text-xs font-bold uppercase tracking-widest text-amber-400" data-id="element-139" data-mp="3ef600urrrra2">
          El verdadero problema
        </p>
        <h2 className="mt-3 text-center font-display text-2xl font-extrabold leading-tight text-white sm:text-3xl" data-id="element-140" data-mp="1k49cdr83r0a5">
          El problema no es que no sepas reparar.
        </h2>
        <p className="mt-3 text-center text-base leading-relaxed text-white/70" data-id="element-141" data-mp="obex0xmbgk94">
          El problema es que sigues trabajando como{" "}
          <span className="font-semibold text-white" data-id="element-142" data-mp="scichj0gce9t">técnico…</span> cuando
          podrías estar operando como un{" "}
          <span className="font-semibold text-amber-400" data-id="element-143" data-mp="x6ctufsl4h5q">negocio.</span>
        </p>

        <p className="mt-6 text-sm leading-relaxed text-white/60" data-id="element-144" data-mp="123d1gv531ryy">
          La mayoría de los técnicos invierte años aprendiendo a reparar
          electrodomésticos, pero nunca aprende cómo administrar el negocio que
          hay detrás. Por eso terminan…
        </p>

        <ul className="mt-5 space-y-2.5" data-id="element-145" data-mp="1g22x06c97jl7">
          {painPoints.map(p => <li key={p} className="flex items-start gap-3 rounded-lg border border-red-500/15 bg-red-500/[0.06] px-3.5 py-3 text-sm text-white/80" data-id="element-146" data-mp="3dtxg7xektcdd">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" data-id="element-147" data-mp="ozqui1ihndsw" />
              {p}
            </li>)}
        </ul>

        <p className="mt-6 text-center text-sm font-semibold text-white/80" data-id="element-148" data-mp="k2h86uqebi9a">
          Trabajan más. Se cansan más. Pero ganan menos de lo que deberían.
        </p>

        <div className="mt-8 rounded-2xl border border-white/10 bg-neutral-900 p-5" data-id="element-149" data-mp="tyu31vxog25m">
          <p className="text-sm leading-relaxed text-white/70" data-id="element-150" data-mp="17z4qsq3ox0mk">
            Los clientes no pueden saber si eres el mejor reparando una lavadora.
            Pero sí pueden notar, desde el primer minuto…
          </p>
          <ul className="mt-4 space-y-2" data-id="element-151" data-mp="1hpg1cvhvq82f">
            {clientNotices.map(c => <li key={c} className="flex items-center gap-2.5 text-sm font-medium text-white" data-id="element-152" data-mp="1cq3e49n3iyzb">
                <CheckIcon className="h-4 w-4 shrink-0 text-amber-400" data-id="element-153" data-mp="1qqe1v3t3zxg9" />
                {c}
              </li>)}
          </ul>
          <p className="mt-4 text-sm leading-relaxed text-white/70" data-id="element-154" data-mp="1lootxx16nzwe">
            El técnico que{" "}
            <span className="font-semibold text-amber-400" data-id="element-155" data-mp="2abeb7gdnol4v">
              parece más profesional
            </span>{" "}
            suele ser el que consigue más recomendaciones, más clientes
            recurrentes y justifica mejor el valor de su servicio.
          </p>
        </div>

        <div className="mt-8 flex justify-center" data-id="element-156" data-mp="20f2xqn2bxp8u">
          <TransformButton label="Quiero dejar de improvisar" data-id="element-157" data-mp="1mksfmoku8tbr" />
        </div>
      </div>
    </section>;
}